/**
 * Reports Core Web Vitals to a configurable sink.
 *
 * In dev: logs to console so you can see metrics during local browsing.
 * In prod: ships to whatever you wire up — Google Analytics 4 by default
 * if the gtag global is present (no-op otherwise, so this is safe to ship
 * before the analytics is set up).
 *
 * Metrics reported:
 *   - LCP (Largest Contentful Paint)        — loading
 *   - INP (Interaction to Next Paint)       — interactivity (replaces FID)
 *   - CLS (Cumulative Layout Shift)         — visual stability
 *   - FCP (First Contentful Paint)          — loading
 *   - TTFB (Time To First Byte)             — server response
 */

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

// Default sink: log in dev, send to gtag in prod if available.
export const defaultReporter = (metric) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(`[web-vitals] ${metric.name} = ${metric.value.toFixed(2)} (${metric.rating})`);
    return;
  }

  // Ship to Google Analytics 4 if gtag is present. Safe no-op otherwise.
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', metric.name, {
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      event_category: 'Web Vitals',
      event_label: metric.id,
      non_interaction: true,
    });
  }
};

export default reportWebVitals;
